import { call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { selectNewVoicemail, selectSavedVoicemail, setNewVoicemail, setSavedVoicemail } from '../../../state/voicemail/voicemailSlice';
import { showSnackbar } from '../../../state/snackbar/snackbarSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';

export function* saveVoicemailSaga(action) {
    try {
        // Fetch user credentials from Redux store
        const { user, domain } = yield select(selectUserCredentials);
        const voicemail = action.payload;

        // API endpoint for retrieving voicemail (relative URL)
        const apiUrl = '?object=audio&action=update';
        // Parameters for the API call
        const params = {
            format: 'json',
            owner: user,
            owner_domain: domain,
            type: voicemail.vmail_type,
            index: voicemail.filename,
            intArray: 'true',
        };
        const response = yield call(cirrusClient.get, apiUrl, { params });
        if (response.status === 202) {

            //Update the State
            const newVoicemails = yield select(selectNewVoicemail);
            const savedVoicemails = yield select(selectSavedVoicemail);

            const updatedNewVoicemails = newVoicemails.filter(vm => vm.index !== voicemail.index);

            const updatedVoicemail = {
                ...voicemail,
                vmail_type: "vmail/save"
            };
            const updatedSavedVoicemails = [updatedVoicemail, ...savedVoicemails];



            yield put(setNewVoicemail(updatedNewVoicemails));
            yield put(setSavedVoicemail(updatedSavedVoicemails));

            yield put(showSnackbar({
                message: `Saved the Voicemail`,
                severity: 'success'
            }));
        }

    }
    catch (error) {
        console.error(error);
        yield put(showSnackbar({
            message: `Error Saving Voicemail`,
            severity: 'error'
        }));


    }
}